var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabTests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 50,
    height: 50,
    rx: 8.75,
    fill: "#E16058"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4473 21.7559L28.2441 13.5527C28.0977 13.4062 27.8535 13.4062 27.707 13.5527L26.0469 15.2129C25.9004 15.3594 25.9004 15.6035 26.0469 15.75L26.584 16.2871L14.7676 28.1035C12.8633 30.0078 12.5215 33.084 14.2793 35.0859C15.3047 36.2578 16.7207 36.8438 18.1367 36.8438C19.4062 36.8438 20.6758 36.3555 21.6523 35.3789L33.7129 23.416L34.25 23.9531C34.3965 24.0996 34.6406 24.0996 34.7871 23.9531L36.4473 22.293C36.5938 22.1465 36.5938 21.9023 36.4473 21.7559ZM28.6836 25.125H21.0176L28.2441 17.9473L32.0527 21.7559L28.6836 25.125Z",
    fill: "#E16058"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTests);
export default __webpack_public_path__ + "static/media/labTests.54ed3ec7.svg";
export { ForwardRef as ReactComponent };